import { render } from "./totalsites.vue?vue&type=template&id=7ce3b653"
import script from "./totalsites.vue?vue&type=script&lang=js"
export * from "./totalsites.vue?vue&type=script&lang=js"

import "./totalsites.vue?vue&type=style&index=0&id=7ce3b653&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__